import { message } from 'antd';
import { getTextVisitPatientList, ITextVisitPatientListParams } from 'api/textVisit';
import { getGroupPracticeTextVisitList } from 'api/group';
import { useCallback, useEffect, useState } from 'react';
import { CaseListItem } from 'types/textVisit';

const useGetProviderTextVisitList = ({
    current = 1,
    size = 10,
    type = 'InProgress',
    clientId,
    autoFetch = true,
    isPracticeView = false,
}: ITextVisitPatientListParams & { autoFetch?: boolean; isPracticeView?: boolean }): [
    CaseListItem[],
    boolean,
    (c: number, s: number, t: 'InProgress' | 'Upcoming' | 'PastDue' | 'Past', cid?: number) => Promise<any[]>,
] => {
    const [appointmentList, setAppointmentList] = useState<CaseListItem[]>([]);
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(
        async (c: number, s: number, t: 'InProgress' | 'Upcoming' | 'PastDue' | 'Past', cid?: number) => {
            if (!cid) {
                return [];
            }

            setLoading(true);
            let res: any[] = [];
            try {
                const resp = isPracticeView
                    ? await getGroupPracticeTextVisitList({ current: c, size: s, type: t, clientId: cid })
                    : await getTextVisitPatientList({ current: c, size: s, type: t, clientId: cid });
                if (resp && !resp.error) {
                    const data = resp?.data?.data?.list || [];
                    res = data;
                    setAppointmentList(data);
                } else {
                    message.error(resp?.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }

            return res;
        },
        [isPracticeView],
    );

    useEffect(() => {
        if (clientId && autoFetch) {
            fetch(current, size, type, clientId);
        }
    }, [current, size, type, clientId, fetch, autoFetch]);

    return [appointmentList, loading, fetch];
};

export default useGetProviderTextVisitList;
